import React from 'react';
import { func, object } from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import BobConfirmButton from './../../../components/BobConfirmButton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';

const DeleteClientModal = ({
    clearErrors,
    client,
    companyInfo,
    deleteClient,
    fetchClients,
    fetchClient,
    isLoading,
    onClose,
    toggleLoading
}) => {
    
    const handleDelete = async () => {
        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            isDeleted = await deleteClient(client.clientId, companyInfo);
        }

        if (isDeleted) {
            const body = {};
            await fetchClients(body);
            handleClose();
        }
    };

    const handleClose = () => {
        clearErrors();
        toggleLoading(false);
        onClose();
    };

    return (
        <React.Fragment>
            <ErrorOutlineIcon className={classes.warningIcon} />
            <div className={classes.text}>
                <p className={classes.desc}> Are you sure you want to delete the entity below?</p>
                <p className={classes.name}>Client</p>
                <p className={classes.entityName}>{client.clientName}</p>
            </div>
            <Button
                className={classes.Button}
                onClick={handleClose}
                variant="contained"
            >
                Cancel
            </Button>
            <BobConfirmButton
                className={classes.ButtonWithMargin}
                isLoading={isLoading}
                label={'Yes'}
                onClick={handleDelete}
            />
        </React.Fragment>
    );
};

DeleteClientModal.defaultProps = {
    selectedNode: {}
};

DeleteClientModal.propTypes = {
    onClose:      func.isRequired,
    selectedNode: object
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        isLoading:   state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteClientModal);
